import Client from '../infra/http/AxiosClient';

export const getUnfollowed = (page, limit, search = '') => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await Client.get(
        `/follows/notfollowers/${page}/${limit}?name=${search}`
      );
      resolve(response);
    } catch (error) {
      reject(error);
    }
  });
};

export const getFollowers = (page, limit, search = '') => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await Client.get(
        `/follows/${page}/${limit}?name=${search}`
      );
      resolve(response);
    } catch (error) {
      reject(error);
    }
  });
};

export const getFollowing = (page, limit, search = '') => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await Client.get(
        `/follows/followers/${page}/${limit}?name=${search}`
      );
      resolve(response);
    } catch (error) {
      reject(error);
    }
  });
};

export const follow = id => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await Client.post('/follows', { memberId: id });
      resolve(response);
    } catch (error) {
      reject(error);
    }
  });
};

export const unfollow = id => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await Client.delete(`/follows/${id}`);
      resolve(response);
    } catch (error) {
      reject(error);
    }
  });
};

export const inviteUser = payload => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await Client.post('/institutions/users', payload);
      resolve(response);
    } catch (error) {
      reject(error);
    }
  });
};

export const getAllUsers = (page, limit, search = {}) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await Client.get(
        `/user/search/${page}/${limit}?filter=${JSON.stringify(search)}`
      );
      resolve(response);
    } catch (error) {
      reject(error);
    }
  });
};

export const getAllNonPaged = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await Client.get(
        `/user/getAll`
      );
      resolve(response);
    } catch (error) {
      reject(error);
    }
  });
};

export const addCategory = id => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await Client.put('/accounts/profile/category/add', {
        category: id
      });
      resolve(response);
    } catch (error) {
      reject(error);
    }
  });
};

export const removeCategory = id => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await Client.delete(
        '/accounts/profile/category/remove',
        { data: { category: id } }
      );
      resolve(response);
    } catch (error) {
      reject(error);
    }
  });
};

export const readUpdates = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await Client.put('/accounts/profile/read-updates');
      resolve(response);
    } catch (error) {
      reject(error);
    }
  });
};



// WEBPACK FOOTER //
// ./src/services/UsersService.js